import { useQuery } from "@apollo/react-hooks";
import { GET_SPENDINGS } from "../api/spending";

// 取使用者最近一筆消費的幣別當表單預設值，避免每次手動選。
// skip = true（編輯既有消費）時不查詢；查詢失敗或沒有歷史紀錄時回傳 undefined。
export default (skip) => {
  const { loading, data } = useQuery(GET_SPENDINGS, {
    variables: { offset: 0, limit: 1 },
    skip,
    onError() {},
  });

  const lastSpending = data && data.spendings && data.spendings[0];

  return {
    loading: !skip && loading,
    currencyId: lastSpending && lastSpending.currency.id,
  };
};
